import { HiOutlineArchiveBox, HiOutlineCube, HiOutlineDocumentText, HiPlus } from 'react-icons/hi2';
import Button from '../../atoms/Button';
import './TableEmptyState.scss';

export interface ITableEmptyStateAction {
    id: string;
    label: string;
    onClick: () => void;
}

export interface ITableEmptyStateProps {
    title: string;
    description?: string;
    icon?: string;
    layout?: 'inline' | 'centered';
    actions?: ITableEmptyStateAction[];
}

const TableEmptyState = ({ title, description, icon, layout = 'inline', actions = [] }: ITableEmptyStateProps) => {
    const Icon = icon === 'package' ? HiOutlineCube : icon === 'document' ? HiOutlineDocumentText : HiOutlineArchiveBox;
    return (
        <div className={`table-empty-state table-empty-state--${layout}`} data-testid="table-empty-state">
            <Icon className="table-empty-state__icon" aria-hidden />
            <div className="table-empty-state__copy">
                <h3 className="table-empty-state__title">{title}</h3>
                {description && <p className="table-empty-state__description">{description}</p>}
            </div>
            {actions.length > 0 && (
                <div className="table-empty-state__actions">
                    {actions.map((action) => (
                        <Button
                            key={action.id}
                            variant="outline-neutral"
                            size="sm"
                            onClick={action.onClick}
                            startAdornment={<HiPlus aria-hidden />}
                        >
                            {action.label}
                        </Button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TableEmptyState;
